import React,  { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ModalReszletesInfo from './ModalReszletesInfo';

import BelepesModal from './BelepesModal';
import NevMegadas from './NevMegadas';
import {Row, Col, Container, Button} from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import RendConf from './RendConf';
import { ikonURL } from '../../ikon';
import { regisztracioCel } from '../../vazlat';
library.add(fas)

// A nyilvános rendezvénylista. Vendégnek és belépettnek ugyanaz; a különbség a jobb felső sarok:
// belépettnek név, e-mail-cím és Kilépés, vendégnek egy szürke felirat. A "Regisztrálok" gomb vendégnek
// belépő ablakot nyit (e-mail vagy Google), belépettnek egyenesen a regisztrációra visz.
// felhasznalo: undefined = a belépés visszaállítása folyamatban, null = vendég, egyébként a belépett felhasználó.
export default function Rendezvenyek({felhasznalo, onKilepes, onSetNev, onGoogleCredential, frissitFelhasznalo, ...props}) {
    const [rendezvenyekByCsoport, setRendezvenyekByCsoport] = useState([]);
    const [rendezvenyForReszletesInfo, setRendezvenyForReszletesInfo] = useState(undefined);
    const [listaBetoltve, setListaBetoltve] = useState(false);
    // A belépő ablak: {rendezveny?, cel?}; undefined = zárva
    const [belepes, setBelepes] = useState(undefined);
    const navigate = useNavigate();
    const location = useLocation();

    const belepett = felhasznalo !== undefined && felhasznalo !== null;

    useEffect(() => {
        // Hogy a rendezvények közül mi látszik (pl. admin), azt a szerver dönti el a belépési tokenből.
        props.callAPI("General.getAktualisRendezvenyekByCsoport", {}, function(resp){
            setRendezvenyekByCsoport(resp.data.rendezvenyekByCsoport);
            setListaBetoltve(true);
        });
    }, [belepett ? felhasznalo.Id : null]);

    // A listára visszatérve a felhasználó megrendelései naprakészek legyenek (pl. frissen kitöltött regisztráció).
    useEffect(() => {
        if (belepett){
            frissitFelhasznalo();
        }
    }, []);

    // Egy védett oldalról átirányított vendég: a belépő ablak magától megnyílik (a célrendezvénnyel vagy céllal).
    const belepesKero = location.state ? location.state.belepes : undefined;
    useEffect(() => {
        if (!belepesKero || felhasznalo !== null || (belepesKero.rendezvenyID && !listaBetoltve)){
            return;
        }
        let rendezveny;
        if (belepesKero.rendezvenyID){
            rendezvenyekByCsoport.forEach(function(csoport){
                csoport.rendezvenyek.forEach(function(r){ if (Number(r.Id) === belepesKero.rendezvenyID){ rendezveny = r; } });
            });
        }
        setBelepes({rendezveny: rendezveny, cel: belepesKero.cel});
        // a kérés elhasználva: a frissítés vagy a Vissza ne nyissa meg újra
        navigate(location.pathname, {replace: true, state: null});
    }, [belepesKero, listaBetoltve, felhasznalo]);

    // A cím és a vonal csak akkor kell, ha van mit listázni
    const vanRendezveny = rendezvenyekByCsoport.some(function(csoport){ return csoport.rendezvenyek.length > 0; });

    // Amíg a belépett felhasználónak nincs neve, nem lehet továbblépni.
    const nevHianyzik = belepett && felhasznalo.Nev === '';

    function onSave_nev(nev){
        onSetNev(nev);
    }

    function onClick_regisztralok(rendezveny){
        if (felhasznalo === undefined){
            return;
        }
        if (felhasznalo === null){
            setBelepes({rendezveny: rendezveny});
        }else if (felhasznalo.Nev !== ''){
            navigate(regisztracioCel(felhasznalo, rendezveny.Id));
        }
    }

    function onClick_megrendeles(rendezveny){
        navigate('/megrendeles/' + felhasznalo.megrendeltRendezvenyekByID[rendezveny.Id].megrendelesID);
    }

    // Van-e érdemi hosszú leírás: a szerkesztő üres bekezdései ("<p></p>", "<p>&nbsp;</p>") nem számítanak.
    function vanReszletesInfo(rendezveny){
        const szoveg = String(rendezveny.Infohtmlhosszu || '')
            .replace(/<(img|iframe|video|hr)/gi, 'X')
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;|&#160;/gi, ' ')
            .trim();
        return szoveg !== '';
    }

    function onClick_rendezveny_reszletes(rendezveny){
        setRendezvenyForReszletesInfo(rendezveny);
    }

    function onHideModal_reszletesInfo(){
        setRendezvenyForReszletesInfo(undefined);
    }

  return (
    <>
    <Container>
        <div className="felhasznaloAdatFejlec">
            <div className="fejlecSor">
                <div className="fejlecCim">
                    <div className="cim">{RendConf.oldal_cim}</div>
                    {RendConf.oldal_alcim_rovid ? <div className="alcim">{RendConf.oldal_alcim_rovid}</div> : undefined}
                    {RendConf.contact_email ?
                        <div className="kapcsolat">Kérdése van? <FontAwesomeIcon icon="fa-envelope" /> <a href={'mailto:' + RendConf.contact_email}>{RendConf.contact_email}</a></div>
                        : undefined
                    }
                </div>
                {/* szélesebb képernyőn a panel közepén; telefonon a panel alatt (lásd lent) */}
                {!nevHianyzik && vanRendezveny ?
                    <div className="fejlecKozep csakDesktop">Aktuális rendezvényeink</div>
                    : undefined
                }
                <div className="fejlecFelhasznalo">
                    {belepett ?
                        <>
                            {felhasznalo.Nev !== '' ? <div className="nev">{felhasznalo.Nev}</div> : undefined}
                            <div className="email">{felhasznalo.Email}</div>
                            <Button variant="outline-secondary" className="kilepesGomb" onClick={onKilepes}>Kilépés</Button>
                        </>
                        : undefined
                    }
                    {felhasznalo === null ?
                        <div className="vendegFelirat">
                            <div>Ön még nem jelentkezett be.</div>
                            <button type="button" className="belepesLink" onClick={function(){ setBelepes({}); }}>Belépés</button>
                        </div>
                        : undefined
                    }
                </div>
            </div>
            {nevHianyzik ?
                <NevMegadas
                    callAPI={props.callAPI}
                    getCommInProgress={props.getCommInProgress}
                    nev={felhasznalo.Nev}
                    onSave={onSave_nev}
                />
                : undefined
            }
        </div>
        {felhasznalo !== undefined && !nevHianyzik && listaBetoltve && !vanRendezveny ?
            <div className="nincsRendezveny">Jelenleg nincs meghirdetett rendezvényünk.</div>
            : undefined
        }
        {!nevHianyzik && vanRendezveny ?
        <div>
            <div className="cim_aktualis_rendezvenyeink csakMobil">Aktuális rendezvényeink</div>
            {rendezvenyekByCsoport.map(function(csoport){
                return (
                    <div key={'cs_' + csoport.Id}>
                        <div className="rendezvenyCsoportCim">
                            {csoport.Cim}
                        </div>

                        {csoport.rendezvenyek.map(function(rendezveny){
                            let marRegisztralt = false;
                            let marRegisztralt_de_nem_fizetett = false;
                            if (belepett){
                                marRegisztralt = felhasznalo.megrendeltRendezvenyekByID[rendezveny.Id] != undefined;
                                if (marRegisztralt){
                                    marRegisztralt_de_nem_fizetett = felhasznalo.megrendeltRendezvenyekByID[rendezveny.Id]['Fizetessikeres'] != 1;
                                }
                            }
                            return (
                                <Row className={"rendezvenybox"} key={"rendID_" + rendezveny.Id} >

                                    <Col className="iconbox" xs={12}>
                                        {rendezveny.Iconfilename ?
                                            <img className="icon" src={ikonURL(rendezveny.Id, rendezveny.Iconfilename)} alt="" onError={function (e) { e.target.style.display = 'none'; }} />
                                            : undefined}
                                    </Col>


                                    <Col className="cimbox" xs={12}>
                                        <div className="cim">
                                            <a name={"rnd" + rendezveny['Id']}>{rendezveny['Cim']}</a>
                                        </div>
                                        <div className="alcim">
                                            {rendezveny.Kezdes}
                                        </div>
                                        <div className="rovidInfo" dangerouslySetInnerHTML={{__html: rendezveny.Infohtmlrovid}} />
                                        <div className={"rovidInfo" + ((rendezveny.szabadFerohelyekSzama < 1) ? " nincs-szabad-ferohely" : "")}>Szabad férőhelyek száma: {rendezveny.szabadFerohelyekSzama}</div>
                                        <br />
                                        {marRegisztralt ?
                                        <div>
                                            {marRegisztralt_de_nem_fizetett ?
                                                <div className="onMarRegisztralt red">
                                                    <div >
                                                        <div className="icon red"><FontAwesomeIcon icon="fa-circle-xmark" size='1x' color="darkred" /></div>
                                                        <div className="text">Ön <b>nem fejezte be</b> regisztrációját erre a rendezvényre!</div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="onMarRegisztralt">
                                                    <div >
                                                        <div className="icon"><FontAwesomeIcon icon="fa-check-circle" size='1x' color="green" /></div>
                                                        <div className="text">Ön már regisztrált erre a rendezvényre!</div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div></div>

                                        }
                                        {vanReszletesInfo(rendezveny) ?
                                        <div className="btnReszletesInfo" onClick={onClick_rendezveny_reszletes.bind(this, rendezveny)}>
                                            <div className="btnInfoIcon"><FontAwesomeIcon icon="fa-info-circle" size='1x' color="#204090" /></div>
                                            <div className="btnInfoText">Részletesebb információkért kattintson ide!</div>
                                        </div>
                                            : undefined
                                        }

                                        {/* a regisztráció gombja a szövegoszlop alján, középen, fölötte vonal */}
                                        <div className="regAlja">
                                            <hr />
                                            {marRegisztralt ?
                                                <Button
                                                    variant="default"
                                                    className="regGomb"
                                                    onClick={onClick_megrendeles.bind(this, rendezveny)}>
                                                    {marRegisztralt_de_nem_fizetett ? 'Folytatom a regisztrációt' : 'Áttekintem a regisztrációmat'}
                                                </Button>
                                                :
                                                <div>
                                                    {rendezveny.szabadFerohelyekSzama > 0 ?
                                                        <div>
                                                            {nevHianyzik ?
                                                                <div>Adja meg nevét!</div>
                                                                :
                                                                <Button
                                                                    className="regGomb"
                                                                    variant="primary"
                                                                    onClick={onClick_regisztralok.bind(this, rendezveny)}>{rendezveny.Gombfelirat}
                                                                </Button>
                                                            }
                                                        </div>
                                                        :
                                                        <div>Már nem lehet regisztrálni</div>
                                                    }
                                                </div>
                                            }

                                        </div>
                                    </Col>

                                </Row>

                            );
                        })}
                    </div>
                )
            })}
        </div>
        : undefined
        }
            <ModalReszletesInfo
                onHide={onHideModal_reszletesInfo}
                show={rendezvenyForReszletesInfo != undefined}
                rendezveny={rendezvenyForReszletesInfo}
            />

        {/* az Adminisztráció gomb az oldal legalján, hogy ne zavarja a fejléc elrendezését */}
        {belepett && (felhasznalo.admin || felhasznalo.auditor) && !nevHianyzik ?
            <div className="adminGombSor oldalAlja">
                <Button variant="outline-primary" onClick={function(){ navigate('/admin'); }}>
                    <FontAwesomeIcon icon="fa-gear" /> Adminisztráció
                </Button>
            </div>
            : undefined
        }
    </Container>

    <BelepesModal
        show={belepes !== undefined}
        rendezveny={belepes ? belepes.rendezveny : undefined}
        cel={belepes ? belepes.cel : undefined}
        onHide={function(){ setBelepes(undefined); }}
        onGoogleCredential={onGoogleCredential}
        onSetNev={onSetNev}
        callAPI={props.callAPI}
        getCommInProgress={props.getCommInProgress} />
    </>
  )
}
